import Notification from '@rio-cloud/rio-uikit/Notification';
import { getSimulatedVehicleStatus } from 'services/simulatedVehicles';

// Status values as returned by the simulated-vehicles API (GET /simulated-vehicles/api/v1/vehicles/{id}).
export const SIMULATED_VEHICLE_STATUS_RUNNING = 'RUNNING';
export const SIMULATED_VEHICLE_STATUS_CREATE_FAILED = 'CREATE_FAILED';

export const NOTIFICATION_TIMEOUT_MS = 5_000;
export const POLL_INTERVAL_MS = 10_000;
export const POLL_TIMEOUT_MS = 300_000;

export interface SimulatedVehicleCreation {
    name: string;
    vin: string;
    vehicleId: string;
    operationId: string;
}

type NotificationType = 'success' | 'info' | 'error';

export const showNotification = (type: NotificationType, title: string, body: string) =>
    Notification[type](<p>{body}</p>, {
        title,
        timeout: NOTIFICATION_TIMEOUT_MS,
        closeButton: true,
        hideProgressBar: false,
    });

const formatIds = ({ vin, operationId }: SimulatedVehicleCreation) => `VIN: ${vin}. Operation ID: ${operationId}`;

export const notifySimulatedVehicleCreationStarted = (creation: SimulatedVehicleCreation) =>
    showNotification('info', `${creation.name} creation started`, formatIds(creation));

const notifyFailure = (title: string, body: string) => showNotification('error', title, body);

// TODO(ATSP-57775): Replace status polling and completion notifications with a vehicle list view showing status and status changes.
export const monitorSimulatedVehicleCreation = async (creation: SimulatedVehicleCreation) => {
    const deadline = Date.now() + POLL_TIMEOUT_MS;

    while (Date.now() < deadline) {
        await new Promise(resolve => setTimeout(resolve, POLL_INTERVAL_MS));

        try {
            const { status } = await getSimulatedVehicleStatus(creation.vehicleId);

            if (status === SIMULATED_VEHICLE_STATUS_RUNNING) {
                showNotification('success', `${creation.name} is running`, `Status: ${status}. ${formatIds(creation)}`);
                return;
            }
            if (status === SIMULATED_VEHICLE_STATUS_CREATE_FAILED) {
                notifyFailure(`${creation.name} creation failed`, `Status: ${status}. ${formatIds(creation)}`);
                return;
            }
        } catch (error) {
            console.error('Failed to fetch simulated vehicle status', error);
        }
    }

    notifyFailure(
        `${creation.name} creation is taking longer than usual`,
        `Status polling stopped after 5 minutes. Check the vehicles list later. ${formatIds(creation)}`
    );
};
